import { useIsLocal } from './use-is-local';

type Config = {
  isLocal: boolean;
};

const getHost = ({ isLocal }: Config) => {
  const url = new URL(window.location.href);
  const { hostname, port } = url;
  const portPart = `:${port}`;
  const portString = `${isLocal ? portPart : ''}`;

  return `https://${hostname}${portString}`;
};

const useHost = () => {
  const isLocal = useIsLocal();
  return getHost({ isLocal });
};

export { useHost };
